import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class CaseHealthModel extends BaseModel {
  @attr("string") case;
  @attr("string") flagName;
  @attr("string") flagDescription;
  @attr("string") errorMessage;
  @attr("string") flagState;
}
